export class Customer {
  idCustomer: number;
  description: string;
  posizione: number;
  image:string;
  lang: string;
}